/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GenerateQuotePdfQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
  quoteId: Types.Scalars['ID']['input'];
  calculationType: Types.QuotePdfCalculationType;
}>;


export type GenerateQuotePdfQuery = { quoteGeneratePdf: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'QuoteGeneratePdfResult', url: string } };

export type GenerateQuoteContractingPdfQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
  quoteId: Types.Scalars['ID']['input'];
  contractingPdfId: Types.Scalars['ID']['input'];
  calculationType: Types.QuotePdfCalculationType;
}>;


export type GenerateQuoteContractingPdfQuery = { quoteGenerateContractingPdf: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'QuoteGenerateContractingPdfResult', url: string } };

export type GenerateQuoteSexyPdfQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
  quoteId: Types.Scalars['ID']['input'];
  pdfTemplateUrl: Types.Scalars['String']['input'];
}>;


export type GenerateQuoteSexyPdfQuery = { quoteGenerateSexyPdf: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'QuoteGenerateSexyPdfResult', url: string } };

export type GenerateQuoteGeneratorPdfQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
  quoteId: Types.Scalars['ID']['input'];
  calculationType: Types.QuotePdfCalculationType;
  pdfGeneratorTemplateId: Types.Scalars['ID']['input'];
}>;


export type GenerateQuoteGeneratorPdfQuery = { quoteGenerateGeneratorPdf: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'QuoteGenerateGeneratorPdfResult', url: string } };


export const GenerateQuotePdfDocument = gql`
    query GenerateQuotePdf($projectId: ID!, $quoteId: ID!, $calculationType: QuotePdfCalculationType!) {
  quoteGeneratePdf(
    projectId: $projectId
    quoteId: $quoteId
    calculationType: $calculationType
  ) {
    ... on QuoteGeneratePdfResult {
      url
    }
  }
}
    `;

/**
 * __useGenerateQuotePdfQuery__
 *
 * To run a query within a React component, call `useGenerateQuotePdfQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateQuotePdfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateQuotePdfQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      quoteId: // value for 'quoteId'
 *      calculationType: // value for 'calculationType'
 *   },
 * });
 */
export function useGenerateQuotePdfQuery(baseOptions: Apollo.QueryHookOptions<GenerateQuotePdfQuery, GenerateQuotePdfQueryVariables> & ({ variables: GenerateQuotePdfQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenerateQuotePdfQuery, GenerateQuotePdfQueryVariables>(GenerateQuotePdfDocument, options);
      }
export function useGenerateQuotePdfLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenerateQuotePdfQuery, GenerateQuotePdfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenerateQuotePdfQuery, GenerateQuotePdfQueryVariables>(GenerateQuotePdfDocument, options);
        }
export function useGenerateQuotePdfSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GenerateQuotePdfQuery, GenerateQuotePdfQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GenerateQuotePdfQuery, GenerateQuotePdfQueryVariables>(GenerateQuotePdfDocument, options);
        }
export type GenerateQuotePdfQueryHookResult = ReturnType<typeof useGenerateQuotePdfQuery>;
export type GenerateQuotePdfLazyQueryHookResult = ReturnType<typeof useGenerateQuotePdfLazyQuery>;
export type GenerateQuotePdfSuspenseQueryHookResult = ReturnType<typeof useGenerateQuotePdfSuspenseQuery>;
export type GenerateQuotePdfQueryResult = Apollo.QueryResult<GenerateQuotePdfQuery, GenerateQuotePdfQueryVariables>;
export const GenerateQuoteContractingPdfDocument = gql`
    query GenerateQuoteContractingPdf($projectId: ID!, $quoteId: ID!, $contractingPdfId: ID!, $calculationType: QuotePdfCalculationType!) {
  quoteGenerateContractingPdf(
    projectId: $projectId
    quoteId: $quoteId
    contractingPdfId: $contractingPdfId
    calculationType: $calculationType
  ) {
    ... on QuoteGenerateContractingPdfResult {
      url
    }
  }
}
    `;

/**
 * __useGenerateQuoteContractingPdfQuery__
 *
 * To run a query within a React component, call `useGenerateQuoteContractingPdfQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateQuoteContractingPdfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateQuoteContractingPdfQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      quoteId: // value for 'quoteId'
 *      contractingPdfId: // value for 'contractingPdfId'
 *      calculationType: // value for 'calculationType'
 *   },
 * });
 */
export function useGenerateQuoteContractingPdfQuery(baseOptions: Apollo.QueryHookOptions<GenerateQuoteContractingPdfQuery, GenerateQuoteContractingPdfQueryVariables> & ({ variables: GenerateQuoteContractingPdfQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenerateQuoteContractingPdfQuery, GenerateQuoteContractingPdfQueryVariables>(GenerateQuoteContractingPdfDocument, options);
      }
export function useGenerateQuoteContractingPdfLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenerateQuoteContractingPdfQuery, GenerateQuoteContractingPdfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenerateQuoteContractingPdfQuery, GenerateQuoteContractingPdfQueryVariables>(GenerateQuoteContractingPdfDocument, options);
        }
export function useGenerateQuoteContractingPdfSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GenerateQuoteContractingPdfQuery, GenerateQuoteContractingPdfQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GenerateQuoteContractingPdfQuery, GenerateQuoteContractingPdfQueryVariables>(GenerateQuoteContractingPdfDocument, options);
        }
export type GenerateQuoteContractingPdfQueryHookResult = ReturnType<typeof useGenerateQuoteContractingPdfQuery>;
export type GenerateQuoteContractingPdfLazyQueryHookResult = ReturnType<typeof useGenerateQuoteContractingPdfLazyQuery>;
export type GenerateQuoteContractingPdfSuspenseQueryHookResult = ReturnType<typeof useGenerateQuoteContractingPdfSuspenseQuery>;
export type GenerateQuoteContractingPdfQueryResult = Apollo.QueryResult<GenerateQuoteContractingPdfQuery, GenerateQuoteContractingPdfQueryVariables>;
export const GenerateQuoteSexyPdfDocument = gql`
    query GenerateQuoteSexyPdf($projectId: ID!, $quoteId: ID!, $pdfTemplateUrl: String!) {
  quoteGenerateSexyPdf(
    projectId: $projectId
    quoteId: $quoteId
    pdfTemplateUrl: $pdfTemplateUrl
  ) {
    ... on QuoteGenerateSexyPdfResult {
      url
    }
  }
}
    `;

/**
 * __useGenerateQuoteSexyPdfQuery__
 *
 * To run a query within a React component, call `useGenerateQuoteSexyPdfQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateQuoteSexyPdfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateQuoteSexyPdfQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      quoteId: // value for 'quoteId'
 *      pdfTemplateUrl: // value for 'pdfTemplateUrl'
 *   },
 * });
 */
export function useGenerateQuoteSexyPdfQuery(baseOptions: Apollo.QueryHookOptions<GenerateQuoteSexyPdfQuery, GenerateQuoteSexyPdfQueryVariables> & ({ variables: GenerateQuoteSexyPdfQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenerateQuoteSexyPdfQuery, GenerateQuoteSexyPdfQueryVariables>(GenerateQuoteSexyPdfDocument, options);
      }
export function useGenerateQuoteSexyPdfLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenerateQuoteSexyPdfQuery, GenerateQuoteSexyPdfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenerateQuoteSexyPdfQuery, GenerateQuoteSexyPdfQueryVariables>(GenerateQuoteSexyPdfDocument, options);
        }
export function useGenerateQuoteSexyPdfSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GenerateQuoteSexyPdfQuery, GenerateQuoteSexyPdfQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GenerateQuoteSexyPdfQuery, GenerateQuoteSexyPdfQueryVariables>(GenerateQuoteSexyPdfDocument, options);
        }
export type GenerateQuoteSexyPdfQueryHookResult = ReturnType<typeof useGenerateQuoteSexyPdfQuery>;
export type GenerateQuoteSexyPdfLazyQueryHookResult = ReturnType<typeof useGenerateQuoteSexyPdfLazyQuery>;
export type GenerateQuoteSexyPdfSuspenseQueryHookResult = ReturnType<typeof useGenerateQuoteSexyPdfSuspenseQuery>;
export type GenerateQuoteSexyPdfQueryResult = Apollo.QueryResult<GenerateQuoteSexyPdfQuery, GenerateQuoteSexyPdfQueryVariables>;
export const GenerateQuoteGeneratorPdfDocument = gql`
    query GenerateQuoteGeneratorPdf($projectId: ID!, $quoteId: ID!, $calculationType: QuotePdfCalculationType!, $pdfGeneratorTemplateId: ID!) {
  quoteGenerateGeneratorPdf(
    projectId: $projectId
    quoteId: $quoteId
    calculationType: $calculationType
    pdfGeneratorTemplateId: $pdfGeneratorTemplateId
  ) {
    ... on QuoteGenerateGeneratorPdfResult {
      url
    }
  }
}
    `;

/**
 * __useGenerateQuoteGeneratorPdfQuery__
 *
 * To run a query within a React component, call `useGenerateQuoteGeneratorPdfQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateQuoteGeneratorPdfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateQuoteGeneratorPdfQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      quoteId: // value for 'quoteId'
 *      calculationType: // value for 'calculationType'
 *      pdfGeneratorTemplateId: // value for 'pdfGeneratorTemplateId'
 *   },
 * });
 */
export function useGenerateQuoteGeneratorPdfQuery(baseOptions: Apollo.QueryHookOptions<GenerateQuoteGeneratorPdfQuery, GenerateQuoteGeneratorPdfQueryVariables> & ({ variables: GenerateQuoteGeneratorPdfQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenerateQuoteGeneratorPdfQuery, GenerateQuoteGeneratorPdfQueryVariables>(GenerateQuoteGeneratorPdfDocument, options);
      }
export function useGenerateQuoteGeneratorPdfLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenerateQuoteGeneratorPdfQuery, GenerateQuoteGeneratorPdfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenerateQuoteGeneratorPdfQuery, GenerateQuoteGeneratorPdfQueryVariables>(GenerateQuoteGeneratorPdfDocument, options);
        }
export function useGenerateQuoteGeneratorPdfSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GenerateQuoteGeneratorPdfQuery, GenerateQuoteGeneratorPdfQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GenerateQuoteGeneratorPdfQuery, GenerateQuoteGeneratorPdfQueryVariables>(GenerateQuoteGeneratorPdfDocument, options);
        }
export type GenerateQuoteGeneratorPdfQueryHookResult = ReturnType<typeof useGenerateQuoteGeneratorPdfQuery>;
export type GenerateQuoteGeneratorPdfLazyQueryHookResult = ReturnType<typeof useGenerateQuoteGeneratorPdfLazyQuery>;
export type GenerateQuoteGeneratorPdfSuspenseQueryHookResult = ReturnType<typeof useGenerateQuoteGeneratorPdfSuspenseQuery>;
export type GenerateQuoteGeneratorPdfQueryResult = Apollo.QueryResult<GenerateQuoteGeneratorPdfQuery, GenerateQuoteGeneratorPdfQueryVariables>;